var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.computedComponents,{tag:"component",attrs:{"booking":_vm.booking,"booking-hotel":_vm.bookingHotel,"booking-hotel-room":_vm.bookingHotelRoom,"selected-order":_vm.getHotelSelection}})}
var staticRenderFns = []

export { render, staticRenderFns }